import { render, staticRenderFns } from "./NewlyOpenedAccount.vue?vue&type=template&id=372b387b&"
import script from "./NewlyOpenedAccount.vue?vue&type=script&lang=js&"
export * from "./NewlyOpenedAccount.vue?vue&type=script&lang=js&"
import style0 from "./NewlyOpenedAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports